import React, {useRef, useState} from 'react';

function Index({label,digits,onChange}) {

    let INPUTS = useRef({input: []})
    let [VALUES, setVALUES] = useState({val: ['','','','','','']})

    const updateValue = (e, index, backspace) => {
        let newVal = e.target.value;
        let Values = VALUES.val
        
        //Paste Values
        if(newVal.length>2){
            let Arr = []
            let OTP = ''
            for(let i=0; i<digits; i++){
                Arr.push(newVal[i])
                OTP = OTP.concat(newVal[i])
            }
            setVALUES({val: Arr})
            onChange(OTP)
            
            return
        }

        if(newVal){
            if(index<digits){
                if(index<digits-1 && !backspace ){
                    INPUTS.current.input[index+1].focus();
                }
                if(newVal.length<2){
                    Values[index] = newVal
                }
            }else if(index<digits){
                Values[index] = newVal
            }
            setVALUES({val: [...Values]})
        }else{
            if(!Values[index] && index!==0){
                INPUTS.current.input[index-1].focus();
            }
            Values[index] = ''
            setVALUES({val: [...Values]})
        }
        
        let number = '';
        VALUES.val.forEach(val => {
            if(!val){
                return
            }
            number = number.concat(val)
        });

        if(number.length===digits){
            console.log(number)
            onChange(number)
        }
    }

    const keyPressed = (event, index) => {        
        var key = event.keyCode || event.charCode;
        if( key === 8){
            updateValue(event, index, true)
        }
    }

    return (
        <div>
            <label className="form-label text-small">{label}</label>
            <div className="d-flex flex-nowrap">
                {
                    [0,0,0,0,0,0].map((x, index)=>{
                        return <input key={index} value={VALUES.val[index]} ref={ref=>INPUTS.current.input[index]=ref} onKeyDown={(e)=>keyPressed(e,index)} onChange={(e)=>updateValue(e,index)} type="text" className="form-control text-center me-2 mb-2" style={{felx:1, textTransform:'uppercase'}} />
                    })
                }
            </div>
        </div>
    );
}

export default Index;